(function () {
  if (window.RDCollectionCategoryNavigationInit) {
    window.RDCollectionCategoryNavigationInit();
    return;
  }

  function setControlVisible(control, visible) {
    if (!control) return;
    if (visible) {
      control.classList.remove("is-nav-hidden");
      control.removeAttribute("hidden");
      var btn = control.querySelector("button");
      if (btn) btn.removeAttribute("disabled");
    } else {
      control.classList.add("is-nav-hidden");
    }
  }

  function updateOverflowState(section) {
    if (!section) return;

    var inner = section.querySelector(".collection-category-navigation__inner");
    var carousel = section.querySelector(".collection-category-navigation__carousel");
    var prevControl = section.querySelector("carousel-prev-button.collection-category-navigation__control");
    var nextControl = section.querySelector("carousel-next-button.collection-category-navigation__control");

    if (!inner || !carousel) return;

    var isOverflowing = carousel.scrollWidth - carousel.clientWidth > 1;
    inner.classList.toggle("is-overflowing", isOverflowing);

    var scrollLeft = Math.abs(carousel.scrollLeft);
    var maxScroll = carousel.scrollWidth - carousel.clientWidth;
    var atStart = scrollLeft < 2;
    var atEnd = maxScroll - scrollLeft < 2;

    setControlVisible(prevControl, isOverflowing && !atStart);
    setControlVisible(nextControl, isOverflowing && !atEnd);
  }

  function resetCarouselToStart(section) {
    if (!section) return;

    var carousel = section.querySelector(".collection-category-navigation__carousel");
    if (!carousel) return;

    function forceScrollStart() {
      carousel.style.setProperty("scroll-snap-type", "none", "important");
      carousel.scrollLeft = 0;
      if (typeof carousel.select === "function") {
        try {
          carousel.select(0, { instant: true });
        } catch (_) {}
      }
      carousel.scrollLeft = 0;
    }

    function restoreAndFinish() {
      carousel.scrollLeft = 0;
      carousel.style.removeProperty("scroll-snap-type");
      updateOverflowState(section);
    }

    forceScrollStart();

    requestAnimationFrame(function () {
      forceScrollStart();
      requestAnimationFrame(function () {
        restoreAndFinish();
      });
    });

    if (!carousel.classList.contains("is-scrollable")) {
      var observer = new MutationObserver(function () {
        if (carousel.classList.contains("is-scrollable")) {
          observer.disconnect();
          forceScrollStart();
          requestAnimationFrame(function () {
            restoreAndFinish();
          });
        }
      });
      observer.observe(carousel, { attributes: true, attributeFilter: ["class"] });
    }
  }

  function initSection(section, options) {
    if (!section) return;

    var settings = options || {};
    var forceResetPosition = !!settings.forceResetPosition;
    var carousel = section.querySelector(".collection-category-navigation__carousel");

    if (!carousel) return;

    if (forceResetPosition || section.dataset.categoryNavStartPositioned !== "true") {
      resetCarouselToStart(section);
      section.dataset.categoryNavStartPositioned = "true";
    }

    updateOverflowState(section);

    if (section.dataset.categoryNavInitialized === "true") return;

    var prevControl = section.querySelector("carousel-prev-button.collection-category-navigation__control");
    var nextControl = section.querySelector("carousel-next-button.collection-category-navigation__control");
    var prevButton = prevControl ? prevControl.querySelector("button") : null;
    var nextButton = nextControl ? nextControl.querySelector("button") : null;

    carousel.addEventListener("scroll", function () {
      updateOverflowState(section);
    }, { passive: true });
    carousel.addEventListener("scrollend", function () {
      updateOverflowState(section);
    });
    carousel.addEventListener("scroll:edge-nearing", function () {
      updateOverflowState(section);
    });
    carousel.addEventListener("scroll:edge-leaving", function () {
      updateOverflowState(section);
    });
    carousel.addEventListener("carousel:settle", function () {
      updateOverflowState(section);
    });

    if ("MutationObserver" in window && (prevButton || nextButton)) {
      var controlsObserver = new MutationObserver(function () {
        updateOverflowState(section);
      });

      if (prevButton) {
        controlsObserver.observe(prevButton, { attributes: true, attributeFilter: ["disabled"] });
      }

      if (nextButton) {
        controlsObserver.observe(nextButton, { attributes: true, attributeFilter: ["disabled"] });
      }
    }

    if ("ResizeObserver" in window) {
      var observer = new ResizeObserver(function () {
        updateOverflowState(section);
      });

      observer.observe(carousel);

      if (carousel.parentElement) {
        observer.observe(carousel.parentElement);
      }
    } else {
      window.addEventListener("resize", function () {
        updateOverflowState(section);
      });
    }

    section.dataset.categoryNavInitialized = "true";
  }

  function initAll(root, options) {
    var context = root || document;
    var sections = context.querySelectorAll(".shopify-section--collection-category-navigation");

    sections.forEach(function (section) {
      initSection(section, options);
    });
  }

  function onReady() {
    initAll(document, { forceResetPosition: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      onReady();
    }, { once: true });
  } else {
    onReady();
  }

  window.addEventListener("pageshow", function (event) {
    if (event && event.persisted) {
      initAll(document, { forceResetPosition: true });
    }
  });

  document.addEventListener("shopify:section:load", function (event) {
    if (!event || !event.target) return;

    if (event.target.matches(".shopify-section--collection-category-navigation")) {
      initSection(event.target, { forceResetPosition: true });
      return;
    }

    initAll(event.target, { forceResetPosition: true });
  });

  window.RDCollectionCategoryNavigationInit = function () {
    initAll(document, { forceResetPosition: true });
  };
})();
